<template>
  <div v-if="label" class="changedItem">
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'ChangedItemLabel',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/audit/ChangedItemLabel.vue